// extracted by mini-css-extract-plugin
export var collapse = "ContentTextSection-module--collapse--21dcd";
export var collapseSection = "ContentTextSection-module--collapseSection--f4ec5";
export var expand = "ContentTextSection-module--expand--ac303";
export var noAnimation = "ContentTextSection-module--noAnimation--965dd";
export var textSection = "ContentTextSection-module--textSection--5f551";